module.exports = __webpack_public_path__ + "media/bed_breakfast.d00371b6.jpg";